import { request } from '../../utility/services/request';
import { Service } from '../base';
import objectToFormData from '../../utility/Utils';
import axios from 'axios';

class FichasService extends Service {
	getList(
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		},
		tipo_ficha = 'activas'
	) {
		const requestId = this.requestPrefixId && `${this.requestPrefixId}-get`;
		return request(
			'GET',
			`${
				tipo_ficha === 'activas'
					? this.baseUrl
					: `${this.baseUrl}/${tipo_ficha}`
			}?page=${params?.page || ''}
				${params.per_page ? `&per_page=${params.per_page}` : ''}
				${params.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`,
			null,
			requestId
		);
	}

	create(values, isFormData) {
		return request('POST', this.baseUrl, values, null, isFormData);
	}

	step(ficha_id, caida_id, values, isFormData) {
		return request(
			'POST',
			`${this.baseUrl}/step/${ficha_id}/${caida_id}`,
			values,
			null,
			isFormData
		);
	}

	finalizar(ficha_id, caida_id) {
		return request('PUT', `${this.baseUrl}/${ficha_id}/${caida_id}/finalizar`);
	}

	getXLS(tipo) {
		return request('GET', `${this.baseUrl}/xls/${tipo}`);
	}

	getAliasById(ficha_id) {
		return request('GET', `${this.baseUrl}/alias/${ficha_id}`);
	}

	relacionar(tipo_relacion, ficha_id, values) {
		return request(
			'POST',
			`${this.baseUrl}/personas_relaciones/${tipo_relacion}/${ficha_id}`,
			values
		);
	}

	crearAlias(ficha_id, values) {
		return request('POST', `${this.baseUrl}/alias/${ficha_id}`, {
			alias: values.values.data,
			tipo: values.values.SelectType
		});
	}

	getRelaciones(tipo_relacion, ficha_id, relacionadas = false, params) {
		return request(
			'GET',
			`${
				this.baseUrl
			}/personas_relaciones/${tipo_relacion}/${ficha_id}?relacionadas=${!!relacionadas}
				${params?.page ? `&page=${params.page}` : ''}
				${params?.per_page ? `&per_page=${params.per_page}` : ''}
				${params?.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params?.order ? `&order=${params.order}` : ''}
			`
		);
	}

	getSignaleticaBlob(caidaId) {
		const url = `${this.baseUrl}/signaletica/${caidaId}`;
		return axios.get(url, {
			responseType: 'blob'
		});
	}
	_delete({ id, file, password }) {
		const body = {
			resolucion: file,
			id,
			password
		};
		return request(
			'POST',
			`${this.baseUrl}/eliminar/${id}`,
			objectToFormData(body),
			null,
			true
		);
	}
	getFichasNoRelacionadas(
		ficha_id,
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		return request(
			'GET',
			`${this.baseUrl}/fichas-no-relacionadas/${ficha_id}?
			${params?.page ? `&page=${params.page}` : ''}
				${params?.per_page ? `&per_page=${params.per_page}` : ''}
				${params?.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params?.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}
	getPersonasNoRelacionadas(
		ficha_id,
		params = {
			page: null,
			per_page: '',
			orderBy: '',
			order: '',
			params: ''
		}
	) {
		return request(
			'GET',
			`${this.baseUrl}/personas-no-relacionadas/${ficha_id}?${
				params?.page ? `&page=${params.page}` : ''
			}
				${params?.per_page ? `&per_page=${params.per_page}` : ''}
				${params?.orderBy ? `&orderBy=${params.orderBy}` : ''}
				${params?.order ? `&order=${params.order}` : ''}
				${params.params ? `&params=${JSON.stringify(params.params)}` : ''}
			`
		);
	}
	finado(id, file) {
		const body = {
			oficio_de_defuncion: file
		};
		return request(
			'PUT',
			`${this.baseUrl}/${id}/finado`,
			objectToFormData(body),
			null,
			true
		);
	}
}

export default FichasService;
